import axios from '@/libs/api.request'

/**
 * 导出设备巡检记录
 */
export const exportInspectionDevice = (top_pid, s_date, e_date) => {
    const data ={
        "top_pid": top_pid,
        "s_date": s_date,
        "e_date": e_date,
    }
    return axios.request({
        url: '/api/admin/deviceinspectionlog/exportNoInspectionDevice',
        data,
        method: 'post'
    })
}

/**
 * 导出月度巡检报告
 */
 export const exportMonth = (month) => {
    const data ={
        "month": month
    }
    return axios.request({
        url: '/api/admin/deviceinspectionreport/exportMonth',
        data,
        method: 'post'
    })
}
